import React from "react";
import PropTypes from "prop-types";
import TooltipCell from "./TooltipCell";
import PlainCell from "./PlainCell";

const ModelTaskRowCellContent = ({ col, value, isTooltipColumn, toggle, disableLink, onTooltipOpen, onNameClick }) =>
	isTooltipColumn ? (
		<TooltipCell col={col} value={value} toggle={toggle} onTooltipOpen={onTooltipOpen} />
	) : (
		<PlainCell col={col} value={value} toggle={toggle} disableLink={disableLink} onNameClick={onNameClick} />
	);

ModelTaskRowCellContent.propTypes = {
	col: PropTypes.string.isRequired,
	value: PropTypes.node,
	isTooltipColumn: PropTypes.bool.isRequired,
	toggle: PropTypes.bool.isRequired,
	disableLink: PropTypes.bool,
	onTooltipOpen: PropTypes.func,
	onNameClick: PropTypes.func,
};

export default ModelTaskRowCellContent;
